import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateEightEnhancedSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateEightEnhancedSection themeColor={themeColor} heading={heading} textColor="white">
      <View>
        {summary && <ResumePDFText themeColor="white">{summary}</ResumePDFText>}
      </View>
    </TemplateEightEnhancedSection>
  );
};
